module.exports = __webpack_public_path__ + "static/img/manual-22.a805cf5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-22.png
// module id = f9rr
// module chunks = 4